<template>
  <div :class="$attrs.class" class="flex flex-col ">
    <div class="flex flex-col sm:flex-row justify-between items-center w-full relative">
      <label v-if="label" class="form-label sm:mr-10" :for="id">{{ label }}:</label>
      <textarea :id="id" ref="input" v-bind="{ ...$attrs, class: null }" class="form-textarea w-full sm:w-96" :class="{ error: error }" :value="modelValue" @input="$emit('update:modelValue', $event.target.value)" />
      <div v-if="error" class="form-error absolute -top-1.5 text-xs px-2 right-2 transform -translate-y-1/2 bg-white whitespace-normal" style="max-width: 350px">{{ error }}</div>
    </div>
  </div>
</template>

<script>
import { v4 as uuid } from 'uuid'

export default {
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      default() {
        return `textarea-input-${uuid()}`
      },
    },
    error: String,
    label: String,
    modelValue: String,
  },
  emits: ['update:modelValue'],
  methods: {
    focus() {
      this.$refs.input.focus()
    },
    select() {
      this.$refs.input.select()
    },
  },
}
</script>
